import React from 'react';
import { Menu } from 'antd';
import EyeDiagram from '../EyeDiagram';
import BathtubCurve from './BathtubCurve';
import './index.css';

const tabsList = [
  { label: "Eye Diagram", key: "eyeDiagram" },
  { label: "Bathtub Curve", key: "bathtubCurve" }
]

class SimulationResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 'eyeDiagram'
    }
  }

  resultContent = (key) => {
    const { resultKey } = this.props;
    switch (key) {
      case 'eyeDiagram':
        return <EyeDiagram type={resultKey} {...this.props} />;
      case "bathtubCurve":
        return <div style={{ position: 'relative', height: "calc(100% - 50px)", width: "100%" }}>
          <BathtubCurve {...this.props} />
        </div>
      default:
        return null;
    }
  }

  render() {
    const { key } = this.state;
    return <div className={`andes-v2-result-content ${key === "bathtubCurve" ? "andes-v2-result-content-waveform" : ""}`}>
      <Menu onClick={(e) => {
        this.setState({ key: e.key });
      }}
        selectedKeys={[key]}
        mode="horizontal"
        items={tabsList}
      />
      {this.resultContent(key)}
    </div>
  }
}

export default SimulationResult;